// import VueCookies from '@/plugins/vueCookies.js';
// 该文件（get-user-set-api.js） 被 store 依赖 ，
// 但是 /plugins/vueCookies 的文件 需要 先加载好 store (使用了 hukeStore)
// 构成了一个引用死循环

import VueCookies from 'vue-cookies'

// console.log(VueCookies, 'VueCookies')

const key = 'user_set_api'

// import store from '@/store'

export function getUserSetApi () {
  // rmSTSToken()
  return VueCookies.get(key)
}

export function setUserSetApi (api) {
  VueCookies.set(key, api)
}

export function rmUserSetApi () {
  VueCookies.remove(key)
}
